import {
  SizeSelection,
  SizeSelection_Size,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';

interface SizeId {
  type: 'id';
  id: string;
}

interface SizeLabel {
  type: 'label';
  label: string;
}

export const getSizeByIdOrLabel = ({
  sizeIdentifier,
  sizeSelection,
}: {
  sizeIdentifier?: SizeId | SizeLabel;
  sizeSelection: SizeSelection | undefined;
}) => {
  if (!sizeIdentifier || !sizeSelection) return undefined;

  switch (sizeSelection.type?.$case) {
    case 'sizes': {
      const sizes = sizeSelection.type.sizes.sizes;
      return findSize(sizeIdentifier, sizes);
    }

    case 'sizeRuns': {
      const sizeRuns = sizeSelection.type.sizeRuns.sizeRuns;
      return sizeRuns[0]?.sizes && findSize(sizeIdentifier, sizeRuns[0].sizes);
    }

    case 'groupedSizes': {
      const sizeGroups = sizeSelection.type.groupedSizes.groups;
      if (sizeGroups[0]?.content?.$case === 'sizes') {
        const sizes = sizeGroups[0].content.sizes.sizes;
        return findSize(sizeIdentifier, sizes);
      }

      if (sizeGroups[0]?.content?.$case === 'sizeRuns') {
        const sizes = sizeGroups[0].content.sizeRuns.sizeRuns[0]?.sizes;
        return sizes && findSize(sizeIdentifier, sizes);
      }

      return undefined;
    }

    case 'inlineSelection': {
      const sizes = sizeSelection.type.inlineSelection.sizes;
      return findSize(sizeIdentifier, sizes);
    }

    case 'oneSize': {
      return sizeSelection.type.oneSize.size;
    }

    default:
      return undefined;
  }
};

const findSize = (
  sizeIdentifier: SizeId | SizeLabel,
  sizes: SizeSelection_Size[],
) => {
  return sizes.find(size => {
    if (sizeIdentifier.type === 'id') {
      return `${size.sizeId}` === sizeIdentifier.id;
    } else {
      return size.label === sizeIdentifier.label;
    }
  });
};
